export const SET_LOADING = 'SET_LOADING'
export const SET_SAVING = 'SET_SAVING'
export const SET_GENERATING = 'SET_GENERATING'
export const SET_PENDING = 'SET_PENDING'
export const SET_TYPE_MODULE = 'SET_TYPE_MODULE'
export const SET_MODE_INVITE = 'SET_MODE_INVITE'



// WEBPACK FOOTER //
// ./src/store/modules/actionState/mutation_types.js